import { baseUrl } from './api.js';

/**
 * Schvalovani MCP tool callu (`/v1/mcp/approvals*`) - sdileny klient pro
 * `/approvals` (plny seznam) i `/dnesek` (rychla akce "Zahodit" u starych
 * pozadavku, ADM1 bod 4). Rozhodnuti je citliva akce - API vyzaduje
 * cerstvou step-up autentizaci (heslo), stejny postup na obou obrazovkach.
 */

export interface McpApprovalItem {
  readonly id: string;
  readonly tool: string;
  readonly status: string;
  /** Krok UXK3 bod 2 — argumenty tool callu, zaklad lidske vety na karte ("Asistentka chce založit zakázku …"). */
  readonly args: unknown;
  readonly requestedBy: string;
  readonly requestedAt: string;
  readonly decidedBy?: string | null;
}

export async function listMcpApprovals(status?: string): Promise<readonly McpApprovalItem[]> {
  const query = status === undefined ? '' : `?status=${status}`;
  const res = await fetch(`${baseUrl}/v1/mcp/approvals${query}`, { credentials: 'include' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = (await res.json()) as { items: McpApprovalItem[] };
  return data.items;
}

/** Step-up (heslo) + rozhodnuti. `stepUpPrompt`/`reason` jsou lokalizovane texty volajici obrazovky. */
export async function decideMcpApproval(
  id: string,
  decision: 'approved' | 'rejected',
  texts: { readonly stepUpPrompt: string; readonly reason: string },
): Promise<void> {
  const password = window.prompt(texts.stepUpPrompt);
  if (password === null) return;
  try {
    await fetch(`${baseUrl}/api/auth/step-up/password`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ password }),
    });
  } catch {
    // Step-up chyba se projevi az odmitnutim rozhodnuti nize - neskryvame ji.
  }
  const res = await fetch(`${baseUrl}/v1/mcp/approvals/${id}/decide`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ decision, reason: texts.reason }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
